import { TypedUseSelectorHook, useSelector } from 'react-redux';
import type { AppRootReducer } from '@/redux/reducers/rootReducer';

export const useAppSelector: TypedUseSelectorHook<AppRootReducer> = useSelector;
